module.exports = __webpack_public_path__ + "static/img/zfg.bdf1416.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/zfg.jpg
// module id = faxz
// module chunks = 1